import React from "react";
import styles from "./footer.module.css";

const Footer: React.FC = () => (
  <footer>
    <h1 className={styles.content}>Alexandria & Morgan</h1>
    <div className={`${styles.content} ${styles.date}`}>Est. 2026</div>
  </footer>
);

export default Footer;
